import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createNewPurchaseRequest, initiatePRProcess, setActiveTab } from "../post-inspection-diy/actions";
import PostInspectionDiyAcceptPrice from "./component";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse,
        isMobile,
        helperVideos
    }
}) => ({
    inspectionResponse,
    isMobile,
    helperVideos
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    createNewPurchaseRequestConnect: createNewPurchaseRequest,
    initiatePRProcessConnect: initiatePRProcess,
    setActiveTabConnect: setActiveTab
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyAcceptPrice);
